export const FORM_NAME = 'MonthlyLeaseChargesOrCredits';
